var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-popup',{ref:"addressPopup",attrs:{"offset":_vm.computedOffset}},[_c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"mb-1"},[_c('div',{staticClass:"fontFamilySET mx-auto text-center rounded",class:['caption', _vm.isLoading ? 'grey lighten-3 animate-pulse grey--text lighten-3' : ''],staticStyle:{"font-family":"Yekan-Bakh-Regular !important"},style:({
          width: 'fit-content',
          minWidth: '80px',
          minHeight: '16px',
        })},[_vm._v(" "+_vm._s(_vm.address || 'آدرسی یافت نشد')+" ")])]),_vm._t("action",null,{"address":_vm.address})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }